import { useAuthContext } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Hook that provides logout functionality with toast notification
 */
export function useLogout() {
  const { signOut } = useAuthContext();
  const navigate = useNavigate();
  const { toast } = useToast();
  const { t } = useLanguage();

  const handleLogout = async () => {
    await signOut();
    navigate("/");
    toast({ title: t("auth.signOutSuccess") });
  };

  return { handleLogout };
}
